module.exports = __webpack_public_path__ + "media/images/dmc/dmc-hero-27a35c6e1dba03c735231a3d1a9fcc01.jpg";